import { deepFreeze } from 'utils/deepFreeze';
import { BannersState } from '.';

const initialState: Readonly<BannersState> = deepFreeze({
  byCategory: {},
});

export default initialState;
